import axios from 'axios'

export default {
  sendHotsiteFeedback ({commit, rootGetters, state}, token) {
    if (state.observation === '') {
      commit('toastr', {
        color: 'error',
        texto: 'É importante deixar seu comentário.'
      })
    } else {
      return axios({
        method: 'post',
        url: process.url + 'Analytics/Feedback',
        timeout: 200000,
        headers: {
          'Token': token
        },
        data: state
      })
    }
  },
  getLogoProvider: async ({commit, getters}, data) => {
    const { data: response } = await axios.get(process.url + 'Hotsite/GetLogo?Type=' + data.type, { headers: { 'Token': data.token } })
    commit('loadLogoProvider', response.resultado)
  },
  async getAllInfoFeedback ({commit, dispatch}, data) {
    commit('toggleLoadingFeedback', true)
    try {
      await dispatch('getLogoProvider', data)
    } catch (e) {
      commit('toastrAxiosError', e)
      commit('toggleLoadingFeedback', false)
    }
    commit('toggleLoadingFeedback', false)
  }
}



// WEBPACK FOOTER //
// ./src/store/hotsite/feedback/actions.js